<template>
  <FormFieldwrap data-pw="consent-check">
    <BaseCheckbox
      v-bind="$attrs"
      :id="id"
      ref="consentInput"
      v-model="model"
      :name="name"
      error-message="Zustimmung ist zur Kontaktaufnahme erforderlich."
    >
      <slot />
    </BaseCheckbox>
  </FormFieldwrap>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import FormFieldwrap from '~/base/components/form/FormFieldwrap.vue'
import BaseCheckbox from '~/base/components/checkbox/Checkbox.vue'

const props = defineProps({
  id: { type: String, default: '' },
  name: { type: String, required: true },
  modelValue: { type: Boolean, default: false }
})
const emits = defineEmits(['update:modelValue'])

const model = computed({
  get () {
    return props.modelValue
  },
  set (newValue) {
    emits('update:modelValue', newValue)
  }
})
</script>
<script lang="ts">
export default {
  inheritAttrs: false
}
</script>
